import { useExperiment } from '@eventbrite/statsig';

/**
 * Hook to get the experiment treatment value for the promoted stack layout test.
 * Returns both loading state and the treatment value to prevent flickering.
 * Uses direct useExperiment hook which properly handles Statsig SDK initialization timing.
 * Link to experiment: https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/experiments/eb_ads_search_result_layout_variant_3
 */
export const usePromotedEventStackExperiment = () => {
    const { isLoading, value } = useExperiment<boolean>(
        'eb_ads_search_result_layout_variant_3',
        'show_eb_ads_search_result_layout_variant_3',
        false,
    );

    return {
        isLoading,
        isEnabled: value,
    };
};
